
import { useIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { useState } from "react"

import {
  Grid
} from "@mui/material";
import Alert from '@mui/material/Alert';
import { Input, Tabs, TabContainer } from "@gpstrackit/react-controls";

const ConfigurationThirdStep = (props) => {

  const { messages } = useIntl();
  const dispatch = useDispatch();
  const [tab, setTab] = useState(0);

  return (
    <Grid>

      <Grid xs={12} style={{ marginTop: 20 }}>
        {
          props.applyScopes.includes("Default") &&
          <Alert severity="error">
            <span>{messages["vidfleet_configuration_apply_scopes_default_message"]}</span>
          </Alert>

        }
        {
          props.applyScopes.includes("All") &&
          <Alert style={{ marginTop: 3 }} severity="error">
            <span>{messages["vidfleet_configuration_apply_scopes_all_message"]}</span>
          </Alert>

        }
        {
          props.applyScopes.includes("Partial") &&
          <Alert severity="info">
            <span>{messages["vidfleet_configuration_apply_scopes_partial_message_2"]}</span>
          </Alert>
        }
      </Grid>
      {
        (props.applyScopes.includes("Default") || props.applyScopes.includes("All")) && !props.codeSent &&
        <Grid xs={12} style={{ marginTop: 20 }}>
          <a className="btn-link align-middle" onClick={() => {
            //to send the verification code
            let manufacturer = props.manufacturers.find(x => x?.name?.toUpperCase() === "VidFleet".toUpperCase())
            dispatch(props.generateValidationCode("updateVidFleetAddConfig", "VidFleet", manufacturer?.id))
            props.setSentVFCC(true);
            props.setCodeSent(true)
          }}>
            {messages["vidfleet_configuration_send_verification_code"]}
          </a>
        </Grid>
      }
      {
        (props.applyScopes.includes("Default") || props.applyScopes.includes("All")) &&
        <Grid xs={12} style={{ marginTop: 20 }}>
          <Input
            type="text"
            label={messages['vidfleet_configuration_verification_code']}
            placeholder={messages['vidfleet_configuration_verification_code']}
            value={props.verificationCode || ""}
            autoComplete="off"
            onChange={(value) => props.setVerificationCode(value?.trim())}
            requiredMessage={messages['required_field']}
            required
            maxLength={20}
          />
        </Grid>
      }

      {
        props?.optionLabels?.length === 0 &&
        <Alert severity="info">
          <span>{messages["vidfleet_configuration_options_default"]}</span>
        </Alert>
      }
      <Tabs tab={tab} onChange={(numberTab) => setTab(numberTab)} scrollButtons>
        {
          props?.optionLabels?.length > 0 &&
          <TabContainer
            label={messages['vidfleet_configuration_label_options']}
            index={0}
          >
            <div style={{ padding: '5px 10px', marginTop: 10, marginBottom: 15 }}>
              <span style={{ fontWeight: "bold" }}>{messages["vidfleet_configuration_options_changed"]}</span>
              {
                props.optionLabels.map((item, index) => {
                  return (
                    <Grid xs={12}>
                      <label htmlFor={index}>
                        {item}
                      </label>
                    </Grid>
                  )
                })
              }
            </div>
          </TabContainer>
        }
        <TabContainer
          label={messages['vidfleet_configuration_json_options']}
          index={props?.optionLabels?.length ? 1 : 0}
        >
          <div style={{ marginTop: 10, marginBottom: 10 }}>
            {props.settings ?
              <pre>
                {JSON.stringify(props.settings, undefined, 2)}
              </pre>
              : <div style={{ display: 'flex', width: '100%', alignItems: 'center', justifyContent: 'center', marginTop: 10, opacity: 0.5 }}>{messages['common_no_information_to_display']}</div>}
          </div>
        </TabContainer>
      </Tabs>
    </Grid>
  )

};
export default ConfigurationThirdStep;